import { render, staticRenderFns } from "./QuotationItem.vue?vue&type=template&id=72e1b708&scoped=true&"
import script from "./QuotationItem.vue?vue&type=script&lang=js&"
export * from "./QuotationItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotationItem.vue?vue&type=style&index=0&id=72e1b708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1b708",
  null
  
)

export default component.exports